import { Form, Switch, Row, Col } from "antd";
import React from "react";
import styled from "styled-components/macro";
import { IPerson } from "../../interfaces/interfaces";
import { useTranslation } from "react-i18next";

const FormRoot = styled(Form)``;

export type TEmailPreferences = Pick<
  IPerson,
  | "email_preferences_general"
  | "email_preferences_chat"
  | "email_preferences_room"
  | "email_preferences_match"
>;

const EMAIL_PREFERENCES_ORDER: (keyof TEmailPreferences)[] = [
  "email_preferences_general",
  "email_preferences_chat",
  "email_preferences_room",
  "email_preferences_match"
];

export const UserProfileEmailPreferencesSection = React.memo(
  ({
    values,
    onChange,
    readonly
  }: {
    values: TEmailPreferences;
    onChange: (values: TEmailPreferences) => void;
    readonly: boolean;
  }) => {
    const { t } = useTranslation("student");

    return (
      <FormRoot layout="vertical">
        {EMAIL_PREFERENCES_ORDER.map((preference) => (
          <Form.Item
            key={preference}
            label={t(`email_preferences.form.${preference}.title`)}
            style={{ marginBottom: 16 }}
          >
            <Row gutter={16}>
              <Col span={6}>
                <Switch
                  checked={values[preference]}
                  disabled={readonly}
                  onChange={(checked) => {
                    onChange({
                      ...values,
                      [preference]: checked
                    });
                  }}
                />
              </Col>
              <Col span={18}>
                <div>
                  {t(`email_preferences.form.${preference}.description`)}
                </div>
              </Col>
            </Row>
          </Form.Item>
        ))}
      </FormRoot>
    );
  }
);
